// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"vn-z","badgeLink":"wn-z","category":"xn-z"};